export const APPROVALS_PENDING_CHANGED_EVENT = "approvals-pending-changed";
const BROADCAST_CHANNEL = "naseebi-approvals-pending";

/**
 * @param {{ delta?: number }} [detail]
 */
export function notifyApprovalsPendingChanged(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(APPROVALS_PENDING_CHANGED_EVENT, { detail }));
  try {
    const bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.postMessage(detail);
    bc.close();
  } catch {
    // BroadcastChannel not available in some environments.
  }
}

export function subscribeApprovalsPendingChanged(handler) {
  if (typeof window === "undefined") return () => {};

  const onWindow = (event) => handler(event?.detail || {});
  window.addEventListener(APPROVALS_PENDING_CHANGED_EVENT, onWindow);

  let bc = null;
  try {
    bc = new BroadcastChannel(BROADCAST_CHANNEL);
    bc.onmessage = (event) => handler(event?.data || {});
  } catch {
    // ignore
  }

  return () => {
    window.removeEventListener(APPROVALS_PENDING_CHANGED_EVENT, onWindow);
    if (bc) {
      bc.onmessage = null;
      bc.close();
    }
  };
}
